export default "__VITE_ASSET__CvSQHdky__"